import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },*/
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
     key: 'lineNum',
     field: FIELDS.LINE_NUM,
     title: 'Line No',
     label: 'Line No',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'statusName',
     field: FIELDS.STATUS_NAME,
     title: 'Status',
     label: 'Status',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'customerReqNo',
     field: FIELDS.CUSTOMER_REQ_NO,
     title: 'Cust Req No',
     label: 'Cust Req No',
     sortable: true,
     hidden: true,
     width: 150,
   },{
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     cell: 'navigation',
     sortable: true,
     locked: true,
     hidden: false,
     width: 150,
  },{
     key: 'mfgName',
     field: FIELDS.MFG_NAME,
     title: 'Mfr',
     label: 'Mfr',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCode',
     field: FIELDS.DATE_CODE,
     title: 'Date Code',
     label: 'Date Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'customerPn',
     field: FIELDS.CUSTOMER_PN,
     title: 'Customer PN',
     label: 'Customer PN',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'needByDate',
     field: FIELDS.NEED_BY_DATE,
     title: 'Need Date',
     label: 'Need Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'quantity',
     field: FIELDS.QUANTITY,
     title: 'Qty',
     label: 'Qty',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'price',
     field: FIELDS.PRICE,
     title: 'Price',
     label: 'Price',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'lineTotal',
     field: FIELDS.LINE_TOTAL,
     title: 'Total',
     label: 'Total',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'salePersonFullName',
     field: FIELDS.SALE_PERSON_FULL_NAME,
     title: 'Sales Person',
     label: 'Sales Person',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Customer',
     label: 'Customer',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'contact',
     field: FIELDS.CONTACT,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'quoteTermsName',
     field: FIELDS.QUOTE_TERMS_NAME,
     title: 'Quote Terms',
     label: 'Quote Terms',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'nsnNumber',
     field: FIELDS.NSNNUMBER,
     title: 'NSN',
     label: 'NSN',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'altNumber',
     field: FIELDS.ALT_NUMBER,
     title: 'Alt Number',
     label: 'Alt Number',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'lotCode',
     field: FIELDS.LOT_CODE,
     title: 'Lot Code',
     label: 'Lot Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'revision',
     field: FIELDS.REVISION,
     title: 'Revision',
     label: 'Revision',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'countryOfOriginName',
     field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
     title: 'COO',
     label: 'COO',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'condition',
     field: FIELDS.CONDITION,
     title: 'Condition',
     label: 'Condition',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'moq',
     field: FIELDS.MOQ,
     title: 'MOQ',
     label: 'MOQ',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'piecePerPkg',
     field: FIELDS.PIECE_PER_PKG,
     title: 'SPQ',
     label: 'SPQ',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'warrantyName',
     field: FIELDS.WARRANTY_NAME,
     title: 'Warranty',
     label: 'Warranty',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'customerDelivery',
     field: FIELDS.CUSTOMER_DELIVERY,
     title: 'Lead Time',
     label: 'Lead Time',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'vendorDelivery',
     field: FIELDS.VENDOR_DELIVERY,
     title: 'Vendor Lead Time',
     label: 'Vendor Lead Time',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'categoryName',
     field: FIELDS.CATEGORY_NAME,
     title: 'Category',
     label: 'Category',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'leadFree',
     field: FIELDS.LEAD_FREE,
     title: 'RoHS',
     label: 'RoHS',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'className',
     field: FIELDS.CLASS_NAME,
     title: 'Class',
     label: 'Class',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'package',
     field: FIELDS.PACKAGE,
     title: 'Item Pkg',
     label: 'Item Pkg',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'physPkg',
     field: FIELDS.PHYS_PKG,
     title: 'Phys Pkg',
     label: 'Phys Pkg',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'harmonizedCode',
     field: FIELDS.HARMONIZED_CODE,
     title: 'HTS',
     label: 'HTS',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'scheduleB',
     field: FIELDS.SCHEDULE_B,
     title: 'Schedule B',
     label: 'Schedule B',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'vendorWarrantyName',
     field: FIELDS.VENDOR_WARRANTY_NAME,
     title: 'V Warranty',
     label: 'V Warranty',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'cost',
     field: FIELDS.COST,
     title: 'Cost',
     label: 'Cost',
     cell: 'formatAmount',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingProviderName',
     field: FIELDS.SHIPPING_PROVIDER_NAME,
     title: 'Ship Via',
     label: 'Ship Via',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingMethodName',
     field: FIELDS.SHIPPING_METHOD_NAME,
     title: 'Ship Method',
     label: 'Ship Method',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'currencyName',
     field: FIELDS.CURRENCY_NAME,
     title: 'Currency',
     label: 'Currency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'exchangeRate',
     field: FIELDS.EXCHANGE_RATE,
     title: 'Exchange Rate',
     label: 'Exchange Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'convertedPrice',
     field: FIELDS.CONVERTED_PRICE,
     title: 'Converted Price',
     label: 'Converted Price',
     cell: 'formatAmountConverted',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'total',
     field: FIELDS.TOTAL,
     title: 'Total',
     label: 'Total',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'convertedTotal',
     field: FIELDS.CONVERTED_TOTAL,
     title: 'Converted Total',
     label: 'Converted Total',
     cell: 'formatCurrencyConverted',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalCost',
     field: FIELDS.TOTAL_COST,
     title: 'Total Cost',
     label: 'Total Cost',
     cell: 'formatAmount',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'buyerPrice',
     field: FIELDS.BUYER_PRICE,
     title: 'Buy Target',
     label: 'Buy Target',
     cell: 'formatAmount',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tempRating',
     field: FIELDS.TEMP_RATING,
     title: 'Temp Rating',
     label: 'Temp Rating',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'size',
     field: FIELDS.SIZE,
     title: 'Size',
     label: 'Size',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'voltage',
     field: FIELDS.VOLTAGE,
     title: 'Voltage',
     label: 'Voltage',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'amperage',
     field: FIELDS.AMPERAGE,
     title: 'Amperage',
     label: 'Amperage',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'resolution',
     field: FIELDS.RESOLUTION,
     title: 'Resolution',
     label: 'Resolution',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'watts',
     field: FIELDS.WATTS,
     title: 'Watts',
     label: 'Watts',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'cdm2',
     field: FIELDS.CDM2,
     title: 'Cdm2',
     label: 'Cdm2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'internalPn',
     field: FIELDS.INTERNAL_PN,
     title: 'Internal PN',
     label: 'Internal PN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'eccn',
     field: FIELDS.ECCN,
     title: 'ECCN',
     label: 'ECCN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'uom',
     field: FIELDS.UOM,
     title: 'UOM',
     label: 'UOM',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'altMfr',
     field: FIELDS.ALT_MFR,
     title: 'Alt Mfr',
     label: 'Alt Mfr',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'sku',
     field: FIELDS.SKU,
     title: 'SKU',
     label: 'SKU',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'contrastRatio',
     field: FIELDS.CONTRAST_RATIO,
     title: 'Contrast Ratio',
     label: 'Contrast Ratio',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'aspectRatio',
     field: FIELDS.ASPECT_RATIO,
     title: 'Aspect Ratio',
     label: 'Aspect Ratio',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'operTemp',
     field: FIELDS.OPER_TEMP,
     title: 'Op. Temp',
     label: 'Op. Temp',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'storTemp',
     field: FIELDS.STOR_TEMP,
     title: 'Stor. Temp',
     label: 'Stor. Temp',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'polarizerType',
     field: FIELDS.POLARIZER_TYPE,
     title: 'Polarizer Type',
     label: 'Polarizer Type',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'backlighting',
     field: FIELDS.BACKLIGHTING,
     title: 'Backlighting',
     label: 'Backlighting',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dataConn',
     field: FIELDS.DATA_CONN,
     title: 'Data Conn',
     label: 'Data Conn',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'blConn',
     field: FIELDS.BLCONN,
     title: 'BLConn',
     label: 'BLConn',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'listPrice',
     field: FIELDS.LIST_PRICE,
     title: 'List Price',
     label: 'List Price',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'resale',
     field: FIELDS.RESALE,
     title: 'Resale',
     label: 'Resale',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'vendorNote',
     field: FIELDS.VENDOR_NOTE,
     title: 'Vendor Note',
     label: 'Vendor Note',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'comments',
     field: FIELDS.COMMENTS,
     title: 'Comments',
     label: 'Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'partComments',
     field: FIELDS.PART_COMMENTS,
     title: 'Part Comments',
     label: 'Part Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     cell: 'checkMArk',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isService',
     field: FIELDS.IS_SERVICE,
     title: 'Service',
     label: 'Service',
     cell: 'checkMArk',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'testingRequested',
     field: FIELDS.TESTING_REQUESTED,
     title: 'Testing Requested',
     label: 'Testing Requested',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
